import Repository from "./repository"

export default {
    /**
     * S21301_契約内容取得処理
     *
     * @param {object} params リクエストパラメータ
     */
    view(params) {
        return Repository.get('/api/s213-contract-details/view', { params: params })
    }
}
